interface NotificationEndpoints {
   GET_POOL_PREVIEW: (poolId: number | string) => string;
   GET_BOARD_PREVIEW: (boardId: number | string) => string;
}

export const NOTIFICATION_ENDPOINTS: NotificationEndpoints = {
   GET_POOL_PREVIEW: (poolId) => `pool/${poolId}/notification/preview`,
   GET_BOARD_PREVIEW: (boardId) => `board/${boardId}/notification/preview`,
};
